import { render, staticRenderFns } from "./messagesCanban.vue?vue&type=template&id=ee74312e&scoped=true&"
import script from "./messagesCanban.vue?vue&type=script&lang=js&"
export * from "./messagesCanban.vue?vue&type=script&lang=js&"
import style0 from "./messagesCanban.vue?vue&type=style&index=0&id=ee74312e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee74312e",
  null
  
)

export default component.exports